module.exports = __webpack_public_path__ + "img/menu-off_01.b2f2f941.png";